var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ReportList',_vm._b({},'ReportList',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }